import { memo } from 'react';
import PropTypes from 'prop-types';

import { distancePrefix } from '../../helpers';

import styles from './Shop.scss';

export const Shop = memo(
  ({ shop: { name, address, distance }, hideAddress, shopAddress = null }) => (
    <div className={styles.Shop}>
      <div className={styles.MetaData}>
        <h2 className={styles.Name}>{name}</h2>
        <em className={styles.Distance}>{distancePrefix(distance)}</em>
        <address className={styles.Address}>{!hideAddress && (shopAddress || address)}</address>
      </div>
    </div>
  ),
);

Shop.displayName = 'Shop';

Shop.propTypes = {
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired,
  }).isRequired,
  hideAddress: PropTypes.bool.isRequired,
  shopAddress: PropTypes.string,
};
